/* mybauer js code */
function test(){
    console.log("testing invoked from test .....");

}
function expandCollapseScreen() {
    var element = document.getElementById("MainContent");
    element.classList.toggle("expand_container");
}

function checkFitInStore() {
    var fitInStoreElement = document.getElementById('custom-stick-fit-in-store');
    if (fitInStoreElement != null && fitInStoreElement.childNodes.length > 0) {
      var fitInStoreValue = $("input[type='radio'][name='fitInStore']:checked").val();
       if (fitInStoreValue == 'true') {
         var storeSelect = document.getElementById('stores');
         storeID = storeSelect.value;
         if (storeID <= 0) {
           const body = JSON.stringify({
             attributes : {
               'CustomStickFitInStoreIndicator': 'false',
               'CustomStickFitInStoreID': ''
             }
           });
           fetch(`${window.routes.cart_update_url}`, {...window.fetchConfig(), ...{ body }})
             .then(response => {return response.json();})
             .catch((error) => {
               console.error('Error:', error);
             });
         }
       }
    }
  }